import { SVGProps } from 'react';

export const BillPayIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 8H11V6H13V8ZM13 11H11V9H13V11ZM13 14H11V12H13V14ZM9 14H3V12H9V14ZM3 9H7V11H3V9ZM3 6H8V8H3V6ZM15.526 0.15C15.231 -0.033 14.862 -0.049 14.553 0.106L11.072 1.846L8.555 0.168C8.219 -0.056 7.781 -0.056 7.445 0.168L4.929 1.846L1.447 0.106C1.138 -0.049 0.77 -0.033 0.475 0.15C0.18 0.332 0 0.653 0 1V19C0 19.347 0.18 19.668 0.475 19.851C0.635 19.951 0.817 20 1 20C1.153 20 1.307 19.965 1.447 19.895L4.929 18.154L7.445 19.832C7.781 20.056 8.219 20.056 8.555 19.832L11.071 18.154L14.553 19.895C14.862 20.05 15.231 20.033 15.526 19.851C15.821 19.668 16 19.347 16 19V1C16 0.653 15.82 0.332 15.526 0.15V0.15Z"
      fill="currentColor"
    />
  </svg>
);
